import Divider from './divider';
export default Divider;
